import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = { class: "text-truncate" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-v fs-5" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_vz_site_clone_modal = _resolveComponent("vz-site-clone-modal")!
  const _component_VZSideDrawer = _resolveComponent("VZSideDrawer")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.siteFilterWithDropdowns,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      activityTab: false,
      addButtonText: `${_ctx.t('pages.site.addSite')}`,
      viewName: "sites",
      onTableRowClick: _ctx.tableRowClick,
      onQueryUpdate: _ctx.handleQueryUpdate,
      onFormSubmit: _ctx.submit,
      onBulkDeleted: _ctx.loadSiteStore,
      permissions: _ctx.permissionModel,
      ref: "datatable"
    }, {
      "cell-name": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(site.name), 1)
      ]),
      "cell-code": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(site.code), 1)
      ]),
      "cell-typeTextCode": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(site.typeTextCode), 1)
      ]),
      "cell-address": _withCtx(({ row: site }) => [
        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(site.addressModel.street) + ", " + _toDisplayString(site.addressModel &&
          site.addressModel.street2 &&
          site.addressModel.street2.length > 0 &&
          `${site.addressModel.street2},`) + " " + _toDisplayString(site.addressModel.city) + ", " + _toDisplayString(site.addressModel.state) + ", " + _toDisplayString(site.addressModel.country) + ", " + _toDisplayString(site.addressModel.postalCode), 1)
        ])), [
          [_directive_tippy, {
          placement: 'top-start',
          allowHTML: true,
          interactive: true,
          content: `<div id='tootip-element' class='tooltip-content'>${
            site.addressModel.street +
            (site.addressModel &&
            site.addressModel?.street2 &&
            site.addressModel.street2.length > 0
              ? `, ${site.addressModel?.street2}, `
              : ', ') +
            site.addressModel?.city +
            ', ' +
            site.addressModel?.state +
            ', ' +
            site.addressModel?.country +
            ', ' +
            site.addressModel?.postalCode
          } 
                  <a
                  title='copy'
                  id='copyIcon'
                  onclick='calltheFunction(event)'
                  class='fas fa-copy fs-5 cursor-pointer' 
                  style='margin-left: 8px;'></a>
                </div>`,
        }]
        ])
      ]),
      "cell-startDate": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.format.convertUTCToLocalDate(site.startDate)), 1)
      ]),
      "cell-status": _withCtx(({ row: site }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': site.status?.toLowerCase() === 'active',
          'badge badge-danger': site.status?.toLowerCase() !== 'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(site.status?.toLowerCase())), 3)
      ]),
      "cell-actions": _withCtx(({ row: site }) => [
        (_ctx.hasPermission(_ctx.permissionModel.update))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.editSite(site)), ["stop"]),
              class: "btn btn-icon btn-primary btn-circle btn-sm"
            }, _hoisted_8, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3",
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = site;
          }
        , ["stop"])
            }, _hoisted_11, 8, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      "cell-clone": _withCtx(({ row: site }) => [
        _createVNode(_component_el_dropdown, {
          placement: "bottom-end",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          trigger: "click",
          onCommand: _ctx.setSiteCloneData
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, { class: "clone-dropdown" }, {
              default: _withCtx(() => [
                (_ctx.hasPermission(_ctx.permissionModel.create))
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 0,
                      command: site,
                      class: "clone-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("pages.user.clone.title")), 1)
                      ]),
                      _: 2
                    }, 1032, ["command"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              type: "button",
              class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-circle btn-sm ms-3"
            }, _hoisted_13)
          ]),
          _: 2
        }, 1032, ["onCommand"])
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "tableForm", "addButtonText", "onTableRowClick", "onQueryUpdate", "onFormSubmit", "onBulkDeleted", "permissions"]),
    (_ctx.openCloneModal)
      ? (_openBlock(), _createBlock(_component_vz_site_clone_modal, {
          key: 0,
          site: _ctx.siteObj,
          onCloneSubmit: _ctx.refreshList,
          onOnCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCloneModal = false))
        }, null, 8, ["site", "onCloneSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_VZSideDrawer, {
      modelValue: _ctx.openDrawer,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.openDrawer) = $event)),
      title: _ctx.sideDrawerTitle,
      icon: _ctx.sideDrawerIcon,
      onClose: _ctx.closeDrawer,
      tabs: _ctx.tabs
    }, null, 8, ["modelValue", "title", "icon", "onClose", "tabs"]),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 1,
          showDialog: _ctx.showDeleteDialog,
          viewName: "sites",
          selectedForAction: [_ctx.selectedForAction.webId],
          deleteText: `${_ctx.t('validation.sureToDelete')} ${_ctx.selectedForAction.name}?`,
          pageName: "branch",
          onClose: _cache[4] || (_cache[4] = 
      () => {
        _ctx.refreshList();
      }
    )
        }, null, 8, ["showDialog", "selectedForAction", "deleteText"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ActivityModal, {
      refresh: _ctx.loading,
      icon: "fs-3 bi bi-diagram-3",
      viewName: "Sites Activity Pulse",
      type: "200,1100,1600,1500,2100"
    }, null, 8, ["refresh"])
  ], 64))
}